import { DateTime } from "luxon"
import { WeekOption } from "./SelectWeekAutocomplete"

export function generateWeeks(start: DateTime) {
    const weeks: WeekOption[] = []
    let currentWeekStart = start.startOf("year")

    for (let i = 0; i < 52; i++) {
        if (currentWeekStart > start.plus({ months: 12 })) break
        const weekEnd = currentWeekStart.endOf("week")
        weeks.push({
            label: `Week ${currentWeekStart.weekNumber}`,
            start: currentWeekStart,
            end: weekEnd,
            weekNumber: currentWeekStart.weekNumber,
        })
        currentWeekStart = weekEnd.plus({ days: 1 })
    }

    return weeks
}
export const colorOptions = [
    { name: "Green", code: "#16a34a" },
    { name: "Yellow", code: "#eab308" },
    { name: "Orange", code: "#ea580c" },
    { name: "Red", code: "#991b1b" },
    { name: "Sky", code: "#0284c7" },
    { name: "Purple", code: "#7e22ce" },
]
